import React, { createContext, useContext, useEffect, useState } from "react";
import { apiClient } from "../utils/apiClient";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hydrateUser = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const userData = await apiClient.get("/auth/me/");
        localStorage.setItem("dstl_user", JSON.stringify(userData));
        setUser(userData);
      } catch (error) {
        apiClient.clearAuthTokens();
        localStorage.removeItem("dstl_user");
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    hydrateUser();
  }, []);

  const login = async (email, password) => {
    const payload = await apiClient.post(
      "/auth/login/",
      { email, password },
      { requiresAuth: false },
    );

    const { access, refresh, user: userData } = payload;
    apiClient.setAccessToken(access);
    localStorage.setItem("refresh_token", refresh);
    localStorage.setItem("dstl_user", JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    apiClient.clearAuthTokens();
    localStorage.removeItem("dstl_user");
    setUser(null);
  };

  const refreshUser = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    try {
      const userData = await apiClient.get("/auth/me/");
      localStorage.setItem("dstl_user", JSON.stringify(userData));
      setUser(userData);
    } catch {
      // keep current user on failure
    }
  };

  const value = {
    user,
    login,
    logout,
    loading,
    refreshUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
